import { createModel } from '@/utils'

export const afterSalesModel = createModel({
  // 商品 ID
  goodsId: '',

  // SKU ID
  skuId: '',

  // 订单编号
  orderNo: '',

  // 订单数据
  orderData: {},

  // 商品数据
  goodsData: {},

  // 是否已发货
  delivered: false,

  // （已发货后）申请数量
  requestAmount: 0,

  // 申请成功返回的售后 ID
  afterSalesId: '',

  // 支持的售后类型
  supportAfterSalesTypes: [],

  // 来自即时配送
  fromInstantDelivery: false,

  // 是否支持自行邮寄
  canSelfDelivery: false,

  // 是否支持上门取货
  canPickup: false,
})
